import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminRoute from '../components/general/admin-route.component';
import AuthRoute from '../components/general/auth-route.component';
import PrivateRoute from '../components/general/private-route.component';
import ConsultantsFinderPage  from '../pages/consultants-finder-page';
import ConsultantSelfPage  from '../pages/consultant-self-page';
import LoginPage from '../pages/login-page';
import ResetPasswordPage from '../pages/reset-password-page';
import SendPasswordResetLinkPage from '../pages/send-password-reset-page';
import SettingsPage from '../pages/settings-page';
import SignupPage from '../pages/signup-page';
import OverviewPage from '../pages/overview-page';
import { CurrentUserContext } from '../utils/contexts/current-user.context';

const RouteContainer = () => {
  const { getCurrentUser } = useContext(CurrentUserContext);
  const user = getCurrentUser();
  const isConsultant = user?.role === 'consultant'

  return (
    <Routes>
      <Route
        exact
        path='/'
        element={user ? (isConsultant ? <Navigate to='/consultantself' /> : <Navigate to='/consultants' />) : <Navigate to='/login' />}
      />
      <Route path='login' element={<AuthRoute component={LoginPage} />} />
      <Route path='signup' element={<AuthRoute component={SignupPage} />} />
      <Route
        path='send-password-reset'
        element={<AuthRoute component={SendPasswordResetLinkPage} />}
      />
      <Route
        path='reset-password'
        element={<AuthRoute component={ResetPasswordPage} />}
      />
      
      <Route
        path='overview'
        element={<PrivateRoute enabled={!isConsultant} component={OverviewPage} />}
      />
      <Route
        path='consultants'
        element={
          <PrivateRoute enabled={!isConsultant} noPadding={true} component={ConsultantsFinderPage} />
        }
      />
      <Route
        path='consultantself'
        element={
          <PrivateRoute noPadding={true} component={ConsultantSelfPage} />
        } 
      />

      <Route
        path='settings'
        element={<AdminRoute component={SettingsPage} />}
      />
    </Routes>
  );
};

export default RouteContainer;
